import { useQueryLoader } from 'react-relay';
import { ReportSubtype } from '../models/Report';
import {
  getTotalDiagnosicAssessmentHistory,
  getTotalOutstandingAssessments,
  getTotalSkillAssessmentHistory,
} from '../graphQLOperations/ReportHub';
import { ReportHubDiagnosticAssessmentTotalQuery } from '../graphQLOperations/__generated__/ReportHubDiagnosticAssessmentTotalQuery.graphql';
import { ReportHubSkillAssessmentsTotalQuery } from '../graphQLOperations/__generated__/ReportHubSkillAssessmentsTotalQuery.graphql';
import { ReportHubOutstandingAssessmentsTotalQuery } from '../graphQLOperations/__generated__/ReportHubOutstandingAssessmentsTotalQuery.graphql';

export const useReportHubQueryLoader = (subtype: ReportSubtype) => {
  const [diagnosticQueryRef, loadDiagnosticQuery] = useQueryLoader<ReportHubDiagnosticAssessmentTotalQuery>(
    getTotalDiagnosicAssessmentHistory,
  );
  const [skillAssessmentQueryRef, loadSkillAssessmentQuery] =
    useQueryLoader<ReportHubSkillAssessmentsTotalQuery>(getTotalSkillAssessmentHistory);

  const [outstandingQueryRef, loadOutstandingQuery] =
    useQueryLoader<ReportHubOutstandingAssessmentsTotalQuery>(getTotalOutstandingAssessments);

  switch (subtype) {
    case ReportSubtype.DIAGNOSTIC_SUMMARY:
      return { queryRef: diagnosticQueryRef, loadQuery: loadDiagnosticQuery };
    case ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY:
      return {
        queryRef: skillAssessmentQueryRef,
        loadQuery: loadSkillAssessmentQuery,
      };
    case ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC:
      return { queryRef: outstandingQueryRef, loadQuery: loadOutstandingQuery };
    default:
      return { queryRef: null, loadQuery: () => {} };
  }
};
